export default "__VITE_ASSET__AUrrnWJF__"